<template>
  <div v-show="$router.history.current.query.lang" class="full-page login-page" :class="{ 'nav-open': $sidebar.showSidebar }">
    <md-toolbar md-elevation="0" class="md-transparent md-toolbar-absolute">
      <div class="md-toolbar-row md-offset">
        <!-- 顶部左侧 -->
        <!-- <div>
          <h3 class="md-title">{{$I18n("umeye")}}</h3>
        </div> -->
        <!-- 顶部右侧 -->
        <div class="md-toolbar-section-end">
          <md-button
            class="md-just-icon md-simple md-round md-toolbar-toggle"
            :class="{ toggled: $sidebar.showSidebar }"
            @click="toggleSidebar"
          >
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </md-button>

          <div
            class="md-collapse"
            :class="{ 'off-canvas-sidebar': responsive }"
          >
            <md-list>
              <md-list-item v-if="host === 'open.kdzn.top'" class="black" :href="$router.history.current.query.lang == 'en'?'https://docs.kdzn.top/en' : 'https://docs.kdzn.top/zh'">
                <i class="material-icons">description</i>
                {{$I18n("document")}}
              </md-list-item>
              <md-list-item v-if="host === 'open.kdzn.top'" class="black" href="#" @click="smallAlertModal = true">
                <md-icon>language</md-icon>
                {{$I18n("language")}}
              </md-list-item>
            </md-list>
          </div>
        </div>
      </div>
    </md-toolbar>
    <!-- 中间 + 底部 -->
    <div class="wrapper wrapper-full-page" @click="toggleSidebarPage">
      <div
        class="page-header header-filter"
        :class="setPageClass"
        filter-color="black"
        :style="setBgImage"

      > 
        <!-- 中间卡片 -->
        <div v-if="['/login','/register'].includes(this.$router.history.current.path)" class="container md-offset" style="padding-top: 30px;">
          <div class="html-title">
            {{$I18n('init_title')}}
          </div>
          <router-view></router-view>
          <!-- <zoom-center-transition
            :duration="pageTransitionDuration"
            mode="out-in"
          >
            
          </zoom-center-transition> -->
        </div>
        <router-view v-else></router-view>


        <!-- 底部内容 -->
        <footer class="footer">
          <div class="container md-offset" style="text-align: center;justify-content: center;">
            <nav></nav>
            <div class="copyright text-center">
            </div>
          </div>
        </footer>
      </div>
    </div>
    <!--弹窗 -->
    <modal v-if="smallAlertModal" @close="smallAlertModalHide">
      <template slot="header">
        <md-button class="md-simple md-just-icon md-round modal-default-button" @click="smallAlertModalHide">
          <md-icon>clear</md-icon>
        </md-button>
      </template>

      <template slot="header">
        语言选择
      </template>
      <template slot="body">
        <md-button class="md-primary language_button" @click="changeLanguage('zh-CN')">中文</md-button>
        <md-button class="md-info language_button" @click="changeLanguage('en')">English</md-button>
        <!-- <md-button class="md-success language_button">法语</md-button> -->
      </template>
    </modal>
  </div>
</template>
<style scoped>
/* 本地样式 */
  .language_button {
    margin-right: 12px;
    margin-left: 12px;
  }
</style>
<script>
// import { ZoomCenterTransition } from "vue2-transitions";
import { Modal } from "@/components";
export default {
  components: {
    Modal,
    // ZoomCenterTransition,
  },
  props: {
    backgroundColor: {
      type: String,
      default: "black",
    },
  },
  inject: {
    autoClose: {
      default: true,
    },
  },
  watch:{
    '$router.history.current.query':{
      handler(){
        return 
      },
      immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      host: window.location.host,
      smallAlertModal: false,
      responsive: false,
      showMenu: false,
      menuTransitionDuration: 250,
      pageTransitionDuration: 100,
      year: new Date().getFullYear(),
    };
  },
  computed: {
    setBgImage() {
      //  style="background: ;"
      return {
        background: `url('/img/haiqora/login-back.png')`,
      };
    },
    setPageClass() {
      return `${this.$route.name}-page`.toLowerCase();
    },
  },
  methods: {
    smallAlertModalHide(){
      this.$data.smallAlertModal = false
    },
    changeLanguage(lang){
      if (lang === "zh-CN"){
        lang = ""
      }
      this.$router.push({query: { lang }})
      this.$router.go(0)
    },


    toggleSidebarPage() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    toggleNavbar() {
      document.body.classList.toggle("nav-open");
      this.showMenu = !this.showMenu;
    },
    closeMenu() {
      document.body.classList.remove("nav-open");
      this.showMenu = false;
    },
    onResponsiveInverted() {
      if (window.innerWidth < 991) {
        this.responsive = true;
      } else {
        this.responsive = false;
      }
    },
  },
  mounted() {
    this.onResponsiveInverted();
    window.addEventListener("resize", this.onResponsiveInverted);
  },
  beforeDestroy() {
    this.closeMenu();
    window.removeEventListener("resize", this.onResponsiveInverted);
  },
  beforeRouteUpdate(to, from, next) {
    // Close the mobile menu first then transition to next page
    if (this.showMenu) {
      this.closeMenu();
      setTimeout(() => {
        next();
      }, this.menuTransitionDuration);
    } else {
      next();
    }
  },
};
</script>
<style lang="scss" scoped>
.html-title{
  font-size: 65px;
  font-weight: 400;
  color: #000;
  font-family: PingFang SC; 
  flex: none;
  min-width: 700px;
  margin-right: 0vw;
  margin-left: -5vw;
  color: #FFF;
  text-align: center;
  max-width: calc(42vw);
  line-height: 70px;
}
@media screen and (max-width: 1500px){
  .html-title{
    max-width: calc(100vw - 700px);
    min-width: 200px;
    font-size: 60px;
  }
}


.header-filter::before{
  background : none !important;  
}
$scaleSize: 0.1;
$zoomOutStart: 0.7;
$zoomOutEnd: 0.46;
@keyframes zoomIn8 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  100% {
    opacity: 1;
  }
}
.wrapper-full-page .zoomIn {
  animation-name: zoomIn8;
}
@keyframes zoomOut8 {
  from {
    opacity: 1;
    transform: scale3d($zoomOutStart, $zoomOutStart, $zoomOutStart);
  }
  to {
    opacity: 0;
    transform: scale3d($zoomOutEnd, $zoomOutEnd, $zoomOutEnd);
  }
}
.wrapper-full-page .zoomOut {
  animation-name: zoomOut8;
}
</style>
